import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { TableData } from '@portal/shared/types/api-response.types';
import { TableState } from '@ui/aos-lib';

import { IndividualConsumptionsTableItem } from '../individual-consumption-table.types';
import { FlowDirection } from '@portal/shared/types/filter.types';
import { Commodity } from '@portal/shared/types/commodity.types';
import { ExportFileType } from 'src/app/services/utility/export-facade.service';

export const IndividualConsumptionTableActions = createActionGroup({
  source: 'Individual Consumption Table',
  events: {
    'Get Grid Data': emptyProps(),
    'Get Grid Data Success': props<TableData<IndividualConsumptionsTableItem>>(),
    'Get Grid Data Failure': props<{ error: string }>(),
    'Payload Updated': emptyProps(),
    'Table State Change': props<{ tableState: TableState }>(),
    'Selected Measuring Period Tab Change': props<{ tabTitle: string }>(),
    'Report Group Id Change': props<{ reportGroupId: string; commodity: Commodity }>(),
    'Flow Direction Filter Change': props<{ flowDir: FlowDirection }>(),
    'Export File': props<{
      order: Record<string, number> | null;
      visibility: Record<string, boolean> | null;
      fileType: ExportFileType;
    }>(),
    'Export File Success': emptyProps(),
    'Export File Failure': props<{ error: string }>()
  }
});
